<template>
    <v-container>
        <v-toolbar dense flat color="transparent">
            <v-toolbar-title class="font-weight-bold">Users</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
                to="/user/create"
                outlined
                color="primary"
                class="font-weight-bold mx-lg-3"
                >Add Users</v-btn
            >
        </v-toolbar>
        <v-row>
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :items-per-page="10"
                    :loading="loading"
                    :options.sync="tableOptions"
                    :server-items-length="totalItems"
                    :sort-by="defaultOrdering.column"
                    :sort-desc="defaultOrdering.descending"
                    multi-sort
                    class="elevation-1"
                >
                    <template v-slot:item="row">
                        <tr
                            class="tm-pointer"
                            @click="$router.push('/user/' + row.item.id)"
                        >
                            <td>{{ row.item.username }}</td>
                            <td>{{ row.item.email }}</td>
                            <td>
                                {{ row.item.is_superuser ? "Admin" : "User" }}
                            </td>
                            <td>
                                {{
                                    $moment(row.item.date_joined).format(
                                        "DD-MM-YYYY HH:mm:ss"
                                    )
                                }}
                            </td>
                            <td>
                                {{
                                    row.item.last_login
                                        ? $moment(row.item.last_login).format(
                                              "DD-MM-YYYY HH:mm:ss"
                                          )
                                        : "-"
                                }}
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            modelPath: "users",
            tableOptions: {},
            totalItems: 0,
            headers: [
                {
                    text: "Name",
                    value: "username"
                },
                {
                    text: "Email",
                    value: "email"
                },
                {
                    text: "Role",
                    value: "is_superuser"
                },
                {
                    text: "Created At",
                    value: "date_joined"
                },
                {
                    text: "Last Login",
                    value: "last_login"
                }
            ],
            defaultOrdering: {
                column: ["date_joined"],
                descending: [true]
            },
            items: [],
            loading: false
        };
    },
    computed: {
        ordering() {
            const { sortBy, sortDesc, page, itemsPerPage } = this.tableOptions;
            let ordering = "";
            if (sortBy)
                sortBy.forEach((val, index, arr) => {
                    ordering += ordering ? "," : "";
                    ordering += (sortDesc[index] ? "-" : "") + val;
                });
            return ordering;
        }
    },
    watch: {
        tableOptions: {
            handler() {
                this.getListOfItems().then(data => {
                    this.items = data.items;
                    this.totalItems = data.total;
                    this.loading = false;
                });
            },
            deep: true
        }
    },
    created() {
        this.getListOfItems().then(data => {
            this.items = data.items;
            this.totalItems = data.total;
            this.loading = false;
        });
    },
    methods: {
        getListOfItems: function() {
            return new Promise(resolve => {
                const {
                    sortBy,
                    sortDesc,
                    page,
                    itemsPerPage
                } = this.tableOptions;
                this.loading = true;

                this.$http({
                    method: "get",
                    url: `/${this.modelPath}`,
                    params: {
                        page: page,
                        itemsPerPage: itemsPerPage,
                        ordering: this.ordering
                    }
                })
                    .then(function(response) {
                        console.log(response.data);
                        let items = response.data.results;
                        const total = response.data.count;
                        resolve({
                            items,
                            total
                        });
                    })
                    .catch(function(err) {
                        console.log(err.response);
                    });
            });
        }
    }
};
</script>
